import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Mail, Lock, Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const { error: err } = await signIn(email, password);
    if (err) {
      setError(
        err.message === "Invalid login credentials"
          ? "E-mail ou senha incorretos"
          : err.message
      );
    }
    setBusy(false);
  };

  const inputBase = {
    width: "100%",
    padding: "11px 12px 11px 40px",
    border: "1px solid rgba(128,128,128,0.08)",
    borderRadius: 8,
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "rgba(128,128,128,0.08)",
    color: "#555",
    transition: "border-color .2s",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #251C59 0%, #1e3a5f 50%, #0f172a 100%)",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        padding: 20,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 15,
          padding: "40px 36px",
          width: "100%",
          maxWidth: 420,
          boxShadow: "0 25px 50px rgba(0,0,0,0.25)",
        }}
      >
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img
            src="/logo-icon.png"
            alt="InstaSolutions"
            style={{ width: 64, height: 64, marginBottom: 12 }}
          />
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "#251C59", margin: 0 }}>
            InstaSolutions
          </h1>
          <p style={{ fontSize: 13, color: "#64748b", margin: "4px 0 0" }}>
            CRM Comercial
          </p>
        </div>

        <h2
          style={{
            fontSize: 18, fontWeight: 600, color: "#1e293b",
            marginBottom: 20, textAlign: "center",
          }}
        >
          Entrar
        </h2>

        {error && (
          <div
            style={{
              background: "#fef2f2", border: "1px solid #fecaca",
              borderRadius: 8, padding: "10px 14px", marginBottom: 16,
              color: "#C02646", fontSize: 13,
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              E-mail
            </label>
            <div style={{ position: "relative" }}>
              <Mail size={16} style={{ position: "absolute", left: 12, top: 13, color: "#94a3b8" }} />
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com" required style={inputBase}
              />
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Senha
            </label>
            <div style={{ position: "relative" }}>
              <Lock size={16} style={{ position: "absolute", left: 12, top: 13, color: "#94a3b8" }} />
              <input
                type={showPw ? "text" : "password"} value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" required minLength={6}
                style={{ ...inputBase, paddingRight: 40 }}
              />
              <button
                type="button" onClick={() => setShowPw(!showPw)}
                style={{ position: "absolute", right: 10, top: 11, background: "none", border: "none", cursor: "pointer", padding: 0 }}
              >
                {showPw ? <EyeOff size={16} color="#94a3b8" /> : <Eye size={16} color="#94a3b8" />}
              </button>
            </div>
          </div>

          <button
            type="submit" disabled={busy}
            style={{
              width: "100%", padding: "12px 0", border: "none", borderRadius: 8,
              background: busy ? "#94a3b8" : "#251C59", color: "#fff",
              fontSize: 14, fontWeight: 500, fontFamily: "inherit",
              cursor: busy ? "not-allowed" : "pointer",
            }}
          >
            {busy ? "Aguarde..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
